import request from '@/utils/request'

const BASE = '/crm/admin_crm.php'

/**
 * 36. 会员列表
 * @param {Object} params { keyword, is_agent, page, page_size }
 */
export const crmLists = (params = {}) => {
  return request.post(`${BASE}?a=lists`, params)
}

/**
 * 37. 会员详情
 * @param {Object} params { id }
 */
export const crmDetail = (params = {}) => {
  return request.post(`${BASE}?a=detail`, params)
}

/**
 * 38. 添加会员
 * @param {Object} params { mem_user, mem_name, mem_nick, mem_dian, mem_img, mem_rank, invite_code, is_agent, mem_pass }
 */
export const crmAdd = (params = {}) => {
  return request.post(`${BASE}?a=add`, params)
}

/**
 * 39. 编辑会员/代理身份
 * @param {Object} params { id, is_agent, mem_user, mem_name, mem_nick, mem_dian, mem_img, mem_rank, invite_code }
 */
export const crmEdit = (params = {}) => {
  return request.post(`${BASE}?a=edit`, params)
}
